@if (deviceSize$ | async; as deviceSize) {
  <mat-dialog-content class="no-scrollbar" [ngClass]="{ mobile: deviceSize.isMobile }">
    <div class="position-relative p-large">
      <img src="assets/glyphs/new-design/partner-app/close.svg" alt="close" class="close-icon" (click)="close()" />

      <div class="custom-column align-items-center">
        <img src="assets/images/policies.svg" alt="Policies" width="130" />
        <div class="w-50">
          <label for="benefit-select" class="f-18 fw-heavy mt-0 mb-x-large">Select a Policy Year</label>
          <ng-select
            class="select-date-icon f-11"
            id="benefit-select"
            dropdownPosition="bottom"
            [searchable]="false"
            [clearable]="false"
            [(ngModel)]="policyGroupId"
          >
            @for (policy of allPolicies; track $index) {
              <ng-option [value]="policy.policyGroupId"
                >{{ policy.startDate | date: DISPLAYABLE_DATE_FORMAT }}-{{
                  policy.endDate | date: DISPLAYABLE_DATE_FORMAT
                }}</ng-option
              >
            }
          </ng-select>
        </div>
        <div class="custom-row my-x-large">
          <app-prudent-button
            buttonType="secondary-blue"
            buttonSize="xx-small"
            title="Cancel"
            classOverrides="fw-heavy"
            (click)="close()"
          />
          <app-prudent-button
            buttonType="primary-blue"
            buttonSize="xx-small"
            title="Apply"
            classOverrides="fw-heavy"
            (click)="selectPolicy()"
          />
        </div>
      </div>
    </div>
  </mat-dialog-content>
}
